import { render } from "./ModalPrintProductBarCode.vue?vue&type=template&id=90b289dc"
import script from "./ModalPrintProductBarCode.vue?vue&type=script&lang=js"
export * from "./ModalPrintProductBarCode.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__